const PATHS = {
  // Unauthenticated Paths //
  signin: "/signin",
  signup: "/signup",
  signupInvitation: "/signup-invitation",
  signupBasic: "/basic-info",
  signupPost: "/post-info",
  signupPackages: "/packages-info",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  home: "/home",
  creatorsHome: "/creators-home",
  contactus: "/contact-us",
  termsConditions: "/terms-conditions",
  privacyPolicy: "/privacy-policy",
  aboutUs: "/about-us",
  influencers: "/influencers",
  influencerSearch: "/influencer-search",
  savedInfluencers: "/saved-influencers",
  influencerDetail: "/influencer-detail",
  marketplace: "/marketplace",
  // Influencer Paths //
  messages: "/messages",
  influencerSupport: "/influencer-support",
  influencerProfile: "/influencer-profile",
  influencerPublicProfile: "/influencer-public-profile",
  editPackages: "/edit-packages",
  addSocialLinks: "/social-links",
  transactions: "/transactions",
  challangeDetail: "/challenge-detail",
  yourProposals: "/your-proposals",
  yourJobs: "/your-jobs",
  viewPitch: "/pitch",
  viewJobDetail: "/job-detail",
  jobsDashboard: "/jobs-dashboard",
  jobInvitations: "/job-invitations",
  // Brand Paths //
  dashboard: "/dashboard",
  challanges: "/challenges",
  addChallange: "/challenges/add-challenge",
  challangeOtherDetail: "/challenges/add-other-detail",
  challangePreview: "/challenges/preview",
  challangePayment: "/challenges/add-payment",
  challangeSuccess: "/challenges/success",
  proposals: "/challenges/proposals",
  brandMessages: "/brand-messages",
  findInfluencers: "/find-influencers",
  myNetwork: "/my-network",
  hireInfluencers: "/hire-influencers",
  hiredInfluencers: "/hired-influencers",
  emails: "/emails",
  reports: "/reports",
  brandTransactions: "/brand-transactions",
  settings: "/settings",
  brandSupport: "/brand-support",
  viewEmail: "/view-email",
  viewInfluencerDetail: "/view-influencer-detail",
  brandSavedInfluencers: "/brand-saved-influencers",
  viewContent: "/view-content",
  leaderboard: "/brand-leaderboard",
  infLeaderboard: "/influencer-leaderboard",
};

export default PATHS;